import { PatternFormat } from 'react-number-format';

const FORMAT = `(###) ### - ####`;
export const PhoneDisplay = ({ phone }: { phone: string }) => {
  return <PatternFormat displayType="text" format={FORMAT} value={phone} />;
};
